import React, { FC } from 'react';
import { useCurrentProject } from '@material-bank/projects-utils';
import { AnalyticsEventLocation } from '@mb/lib';
import { CategoryPill } from '../CategoryPill';
import { DynamicIcon } from '../icons/DynamicIcon';
import { CardAttributesType, CategoryType } from '../types';
import styles from './modalSidebar.module.scss';

interface ModalSidebarProps {
  id: string;
  index: number;
  cardAttributes: CardAttributesType;
  categories: CategoryType[];
  activeFilters: string[];
  onCategoryClick: (value: string) => void;
}

export const ModalSidebar: FC<ModalSidebarProps> = ({
  id,
  index,
  cardAttributes,
  categories,
  activeFilters,
  onCategoryClick,
}) => {
  const { currentProject } = useCurrentProject();

  const handleCategoryClick = (value: string) => {
    dataLayer.push({
      event: 'contentblock_filter_click',
      contentblock_title: cardAttributes.title,
      contentblock_id: id,
      contentblock_type: cardAttributes.type,
      contentblock_template: cardAttributes.template,
      event_location: AnalyticsEventLocation.CATALOG,
      contentblock_location: index,
      event_project_id: currentProject?.externalId,
      interaction_element: value,
    });
    onCategoryClick(value);
  };
  return (
    <div
      className={`${styles.modalSidebar} ${styles[cardAttributes.template]}`}
    >
      <div className={styles.modalSidebarIcon}>
        <DynamicIcon iconUrl={cardAttributes.iconType} />
      </div>
      <h2 className={styles.modalSidebarTitle}>{cardAttributes.title}</h2>
      <p className={styles.modalSidebarDescription}>
        {cardAttributes.description}
      </p>
      <ul className={styles.modalSidebarCategoryList}>
        {categories.map((category) => (
          <li key={category.value}>
            <CategoryPill
              value={category.value}
              name={category.name}
              selected={activeFilters.includes(category.value)}
              theme={cardAttributes.template}
              onHandleCategoryClick={handleCategoryClick}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};
